const EXPAND = 'expand';
const CLOSING = 'closing';
const CLOSED = 'closed';
function expandReducer(initialState, action) {
    switch (action.type) {
        case 'expand': {
            return {
                isExpanded: true,
                isVisible: true,
                startAnimation: true,
            };
        }
        case 'closing': {
            return {
                isExpanded: false,
                isVisible: true,
                startAnimation: true,
            };
        }
        case 'closed': {
            return {
                isExpanded: false,
                isVisible: false,
                startAnimation: true,
            };
        }
        default: {
            return initialState;
        }
    }
}
const initialState = {
    isExpanded: false,
    isVisible: false,
    startAnimation: false,
};

export { CLOSED, CLOSING, EXPAND, expandReducer, initialState };
